<div class="sftp-settings-list-filters-content"></div>
